import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { Config } from '../config';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { AuthService } from './authService';
import { TelemetryService } from './telemetryService';
import { FirebaseNotificationService } from './notificationService';
import { ActivityInboxService } from './activityInboxService';
export class FirebaseService {
    constructor(logger) {
        this.logger = logger;
        this.config = new Config();
        // Firebase configuration
        const firebaseConfig = {
            apiKey: 'AIzaSyBvn-TFcfP3xPP0YUurC0aN70QWZOT-HTA',
            authDomain: 'stanorai-outreach.firebaseapp.com',
            projectId: 'stanorai-outreach',
            storageBucket: 'stanorai-outreach.appspot.com',
            messagingSenderId: '962525627369',
            appId: '1:962525627369:web:812ee588acef8fccdf4178',
            measurementId: 'G-W32Q6M4S6P'
        };
        // Initialize Firebase
        this.app = initializeApp(firebaseConfig);
        this.auth = getAuth(this.app);
        this.analytics = getAnalytics(this.app);
        this.storage = getStorage(this.app);
        this.firestore = getFirestore(this.app);
        // Configure emulator in development
        if (this.config.isDev) {
            this.configureEmulator();
            this.configureAnalyticsDebug();
        }
    }
    configureEmulator() {
        connectAuthEmulator(this.auth, 'http://localhost:9099', { disableWarnings: true });
        this.logger.info('Firebase Auth emulator connected');
        connectStorageEmulator(this.storage, 'localhost', 9199);
        this.logger.info('Firebase Storage emulator connected');
        connectFirestoreEmulator(this.firestore, 'localhost', 8080);
        this.logger.info('Firebase Firestore emulator connected');
    }
    configureAnalyticsDebug() {
        // Enable debug mode for Firebase Analytics DebugView
        // This must be done before any events are sent
        if (typeof window !== 'undefined') {
            window.gtag_enable_debug_mode = true;
            // Also set via dataLayer if available
            const windowWithDataLayer = window;
            if (windowWithDataLayer.dataLayer) {
                windowWithDataLayer.dataLayer.push(['config', 'G-W32Q6M4S6P', {
                        debug_mode: true
                    }]);
            }
        }
        this.logger.info('Firebase Analytics debug mode configured for DebugView');
    }
    /**
     * Create a new AuthService instance with proper dependency injection
     */
    createAuthService() {
        return new AuthService(this.auth, this.logger.createChild('Auth'));
    }
    /**
     * Create a new TelemetryService instance with proper dependency injection
     */
    createTelemetryService() {
        return new TelemetryService(this.analytics, this.logger.createChild('Telemetry'), this.config);
    }
    createNotificationService() {
        return new FirebaseNotificationService(this.firestore, this.logger.createChild('Notification'));
    }
    createActivityInboxService() {
        return new ActivityInboxService(this.firestore, this.logger.createChild('ActivityInbox'));
    }
}
